require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-development-policy-finance-reform.json") })
        }
      }, "path---en-us-update-development-policy-finance-reform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-development-policy-finance-reform!./.cache/json/en-us-update-development-policy-finance-reform.json
// module id = 653
// module chunks = 231608221292675